import React from "react";
import ArrowDropIconImage from "../../assets/images/ArrowDrop.svg";

const ArrowDropIcon = ({ style = {} }) => {
  return (
    <img
      src={ArrowDropIconImage}
      alt="Sort"
      className="arrow-drop-icon"
      style={style}
    />
  );
};

export default ArrowDropIcon;
